// Property type of a manual off-market/supplemental listing. `id` is the stored CF property-type code
// (SFR/CND/FRM/... — soldsmodify_output_1.cfm) so it maps directly to the API's `propertyType` field
// and the form's radio values. Modeled on src/type/off-market-status.ts / src/type/lead-status.ts.
class Type {

	public static SINGLE_FAMILY = new Type("SFR", "Single Family");
	public static CONDO = new Type("CND", "Condo");
	public static FARM = new Type("FRM", "Farm");
	public static RENTAL = new Type("RNT", "Rental");
	public static RESIDENTIAL_INCOME = new Type("RI", "Residential Income");
	public static LOT_LAND = new Type("LL", "Lot/Land");
	public static MOBILE_HOME = new Type("MH", "Mobile Home");

	private constructor(
		public readonly id: "SFR" | "CND" | "FRM" | "RNT" | "RI" | "LL" | "MH",
		public readonly label: string,
	) {
	}

	public static values(): Type[] {
		return Object.values(Type);
	}

	public static getById(id: string) {
		return this.values().find(value => value.id === id);
	}

}

export { Type as OffMarketPropertyType };
